module.exports = __webpack_public_path__ + "static/img/govcard_09.f908be72.svg";